<template>
    <div class="row mx-0">
        <div class="flex-grow-1">
            <textarea :value="note.body"
                      @input="e => updateDocNote({idx, data: {body: e.target.value}})"
                      type="text"
                      :disabled="disabled"
                      class="form-control mb-2"
                      placeholder="Note">
            </textarea>
        </div>
        <div>
            <button @click="updateDocNote({idx, data: {isDeleted: true}})"
                    v-tooltip="'Delete note'"
                    class="btn btn-sm text-danger">
                <i class="fal fa-trash-alt fa-lg"></i>
            </button>
        </div>
    </div>
</template>
<script>
import {mapMutations} from 'vuex'
import {DOC_NOTE_UPDATE} from '@/store/modules/doc-viewer'

export default {
    name: 'DocNote',
    props: {
        idx: {},
        note: {},
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        ...mapMutations('doc_viewer', {
            updateDocNote: DOC_NOTE_UPDATE
        })
    }
}
</script>

<style lang="scss">
</style>
